"use client";

export function LengthPicker({
  lengths,
  active,
  onChange,
}: {
  lengths: number[];
  active: number;
  onChange: (length: number) => void;
}) {
  // Step 6.6 guard: don't render when there's no length axis. Caller
  // (DetailPricingPanel) already gates by purchaseUnit + lengths.length>1
  // but defense-in-depth keeps the picker out of pages that wire it
  // incorrectly in the future.
  if (!lengths || lengths.length === 0) return null;
  return (
    <div data-testid="detail-length-picker" className="flex flex-wrap gap-2">
      {lengths.map((l) => {
        const isActive = l === active;
        return (
          <button
            key={l}
            type="button"
            data-testid={`detail-length-${l}`}
            aria-pressed={isActive}
            onClick={() => onChange(l)}
            className={
              isActive
                ? "rounded-full bg-brand-teal px-4 py-1.5 text-sm font-semibold text-white"
                : "rounded-full border border-brand-border bg-white px-4 py-1.5 text-sm font-medium text-brand-text-muted hover:border-brand-teal hover:text-brand-text"
            }
          >
            {l} cm
          </button>
        );
      })}
    </div>
  );
}
